import { render, staticRenderFns } from "./CollapsibleCardButtons.vue?vue&type=template&id=6d8a24d8&"
import script from "./CollapsibleCardButtons.vue?vue&type=script&lang=js&"
export * from "./CollapsibleCardButtons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports